export const SELECT_CHART = 'SELECT_CHART';
export const SELECT_CHART_TYPE = 'SELECT_CHART_TYPE';
export const TOGGLE_RETIREMENT_SHOW_AS = 'TOGGLE_RETIREMENT_SHOW_AS';
export const FETCH_SIMULATION_CURRENT_WANT = 'FETCH_SIMULATION_CURRENT_WANT';
export const FETCH_SIMULATION_CURRENT_WANT_SUCCESS = 'FETCH_SIMULATION_CURRENT_WANT_SUCCESS';
export const FETCH_SIMULATION_CURRENT_WANT_ERROR = 'FETCH_SIMULATION_CURRENT_WANT_ERROR';
export const FETCH_SIMULATION_CURRENT_HAVE = 'FETCH_SIMULATION_CURRENT_HAVE';
export const FETCH_SIMULATION_CURRENT_HAVE_SUCCESS = 'FETCH_SIMULATION_CURRENT_HAVE_SUCCESS';
export const FETCH_SIMULATION_CURRENT_HAVE_ERROR = 'FETCH_SIMULATION_CURRENT_HAVE_ERROR';
export const POST_SIMULATION = 'POST_SIMULATION';
export const POST_SIMULATION_SUCCESS = 'POST_SIMULATION_SUCCESS';
export const POST_SIMULATION_ERROR = 'POST_SIMULATION_ERROR';
export const SELECT_AGE = 'SELECT_AGE';
export const SELECT_DOLLAR_TYPE = 'SELECT_DOLLAR_TYPE';

export const selectChart = (selectedChart: string) => ({
  type: SELECT_CHART,
  payload: selectedChart,
});

export const selectChartType = (chartType: string) => ({
  type: SELECT_CHART_TYPE,
  payload: chartType,
});

export const selectDollarType = (dollarType: string) => ({
  type: SELECT_DOLLAR_TYPE,
  payload: dollarType,
});

export const selectAge = (age: number) => ({
  type: SELECT_AGE,
  payload: age,
});

export const toggleRetirementShowAs = (showAsOption: string) => ({
  type: TOGGLE_RETIREMENT_SHOW_AS,
  payload: showAsOption,
});

export const fetchSimulationCurrentWant = () => ({
  type: FETCH_SIMULATION_CURRENT_WANT,
});

export const fetchSimulationCurrentWantSuccess = (payload: any) => ({
  type: FETCH_SIMULATION_CURRENT_WANT_SUCCESS,
  payload,
});
export const fetchSimulationCurrentWantError = (payload: any) => ({
  type: FETCH_SIMULATION_CURRENT_WANT_ERROR,
  payload,
});

export const fetchSimulationCurrentHave = (mStarRequestId: string) => ({
  type: FETCH_SIMULATION_CURRENT_HAVE,
  payload: mStarRequestId,
});

export const fetchSimulationCurrentHaveSuccess = (payload: any) => ({
  type: FETCH_SIMULATION_CURRENT_HAVE_SUCCESS,
  payload,
});
export const fetchSimulationCurrentHaveError = (payload: any) => ({
  type: FETCH_SIMULATION_CURRENT_HAVE_ERROR,
  payload,
});

export const postSimulation = (payload: any) => ({
  type: POST_SIMULATION,
  payload,
});
